import React from 'react';
import { NpsDistributionDto } from '@area-restrita/api-client/model/npsDistributionDto';

import { Badge } from '@/components/ui/badge';
import { formatApiPercent, formatInteger } from '@/modules/nps/utils';

interface IProps {
  distribution: NpsDistributionDto;
}

const NpsResultsDistribution: React.FC<IProps> = ({ distribution }) => {
  const rows = [
    {
      label: 'Promotores',
      count: distribution.promoterCount,
      percentage: distribution.promoterPercentage,
    },
    {
      label: 'Neutros',
      count: distribution.neutralCount,
      percentage: distribution.neutralPercentage,
    },
    {
      label: 'Detratores',
      count: distribution.detractorCount,
      percentage: distribution.detractorPercentage,
    },
  ];

  return (
    <div className="flex flex-col gap-3">
      <h3 className="text-base font-semibold">Distribuição das respostas</h3>
      {rows.map((row) => (
        <div key={row.label} className="flex flex-col gap-1">
          <div className="flex items-center justify-between gap-3 text-sm">
            <span className="font-medium">{row.label}</span>
            <div className="flex items-center gap-2">
              <span className="text-muted-foreground">
                {formatInteger(row.count)}
              </span>
              <Badge variant="secondary">
                {formatApiPercent(row.percentage)}
              </Badge>
            </div>
          </div>
          <div className="h-2 overflow-hidden rounded-sm bg-muted">
            <div
              className="h-full rounded-sm bg-primary"
              style={{ width: `${Math.min(row.percentage, 100)}%` }}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default NpsResultsDistribution;
